import { LayoutGrid, List, Calendar } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { cn } from "../../../lib/utils";

export type ViewMode = "table" | "list";

interface ViewModeSwitcherProps {
  value: ViewMode;
  onChange: (mode: ViewMode) => void;
  className?: string;
}

const viewModes: { value: ViewMode; label: string; icon: typeof LayoutGrid }[] = [
  { value: "table", label: "Bảng", icon: LayoutGrid },
  { value: "list", label: "Danh sách", icon: List },
];

export function ViewModeSwitcher({ value, onChange, className }: ViewModeSwitcherProps) {
  return (
    <div className={cn("flex items-center gap-1 rounded-md bg-muted p-1", className)}>
      {viewModes.map((mode) => {
        const Icon = mode.icon;
        const isActive = value === mode.value;

        return (
          <Button
            key={mode.value}
            variant={isActive ? "default" : "ghost"}
            size="sm"
            onClick={() => onChange(mode.value)}
            className={cn(
              "gap-2",
              isActive && "shadow-sm"
            )}
            data-testid={`button-view-${mode.value}`}
          >
            <Icon className="h-4 w-4" />
            <span className="hidden sm:inline">{mode.label}</span>
          </Button>
        );
      })}
    </div>
  );
}
